import { openModal } from '@core/components/ModalStack';
import { AddCalendarEventOverlayProps } from './AddCalendarEventOverlay';

export async function openAddCalendarOverlay(props: AddCalendarEventOverlayProps) {
  const { AddCalendarEventOverlay } = await import('./AddCalendarEventOverlay');

  openModal(AddCalendarEventOverlay, props);
}
